import { useEffect } from 'react';
import { handleCondition } from '../../utils/conditionHandler';

/**
 * Невидимый компонент для обработки условных переходов
 * Автоматически определяет следующий блок на основе значения переменной
 */
function ConditionHandler({ block, variables = {}, onNext }) {
  useEffect(() => {
    const nextId = handleCondition(block, variables);
    if (nextId) {
      // Небольшая задержка для корректной работы React
      const timer = setTimeout(() => {
        onNext(nextId);
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [block, variables, onNext]);

  // Не рендерит ничего видимого
  return null;
}

export default ConditionHandler;

